import { Button, MenuItem, TextField } from "@mui/material";
import type { GridColDef } from "@mui/x-data-grid";
import { useState } from "react";
import { useNavigate } from "react-router-dom";

import { DataTable, DateText, MoneyText, PageHeader, StatusChip, useListParams } from "../components";
import { client, unwrap } from "../crm_customers/useData";
import { useQuery } from "@tanstack/react-query";
import help from "./HELP.md?raw";
import { useOpportunityMutations, type Opportunity } from "./useData";

export function Opportunities() {
  const navigate = useNavigate();
  const [params, setParams] = useListParams({ ordering: "-created_at" });
  const list = useQuery({ queryKey: ["opportunities-list", params], queryFn: () => unwrap<{ count: number; results: Opportunity[] }>(client.GET("/api/v1/crm/opportunities/", { params: { query: params } })) });
  const { reopen } = useOpportunityMutations();
  const [status, setStatus] = useState("");
  const columns: GridColDef<Opportunity>[] = [
    { field: "number", headerName: "Number", width: 110 },
    { field: "name", headerName: "Opportunity", flex: 1 },
    { field: "customer_name", headerName: "Customer", width: 200 },
    { field: "stage_name", headerName: "Stage", width: 130 },
    { field: "status", headerName: "Status", width: 100, renderCell: (p) => <StatusChip status={p.value as string} /> },
    { field: "amount", headerName: "Amount", width: 130, renderCell: (p) => <MoneyText amount={p.value as string} currency={p.row.currency} /> },
    { field: "weighted_amount", headerName: "Weighted", width: 130, renderCell: (p) => <MoneyText amount={p.value as string} currency={p.row.currency} /> },
    { field: "expected_close", headerName: "Close", width: 120, renderCell: (p) => <DateText value={p.value as string} /> },
    { field: "owner_email", headerName: "Owner", width: 180 },
    { field: "actions", headerName: "", width: 100, sortable: false, renderCell: (p) => p.row.status !== "open" ? <Button size="small" onClick={() => reopen.mutate(p.row.id)}>Reopen</Button> : null },
  ];
  return (
    <>
      <PageHeader help={help} title="Opportunities" crumbs={[{ label: "CRM" }, { label: "Opportunities" }]} actions={<Button variant="outlined" onClick={() => navigate("/app/crm/pipeline")}>Pipeline board</Button>} />
      <DataTable viewKey="crm.opportunity.list" columns={columns} data={list.data} isLoading={list.isLoading} params={params} onParamsChange={setParams} exportPath="/api/v1/crm/opportunities/export/"
        onRowClick={(row) => navigate(`/app/crm/customers/${row.customer}`)}
        filters={<TextField select size="small" label="Status" value={status} onChange={(e) => { setStatus(e.target.value); setParams({ ...params, status: e.target.value, page: 1 }); }} sx={{ width: 130 }}><MenuItem value="">All</MenuItem><MenuItem value="open">Open</MenuItem><MenuItem value="won">Won</MenuItem><MenuItem value="lost">Lost</MenuItem></TextField>} />
    </>
  );
}
